import { COLOR_HEX, PlayerState, RingSize, SIZES } from '@otrio/engine';

interface PieceTrayProps {
  player: PlayerState;
  selectedSize: RingSize | null;
  onSelectSize: (size: RingSize) => void;
  onDragStart: (size: RingSize) => void;
  onDragEnd: () => void;
}

const PIECE_VISUAL: Record<RingSize, { viewSize: number; r: number; sw: number }> = {
  small:  { viewSize: 54,  r: 18, sw: 9  },
  medium: { viewSize: 74,  r: 28, sw: 11 },
  large:  { viewSize: 100, r: 38, sw: 13 },
};

const SIZE_LABELS: Record<RingSize, string> = {
  small: 'Small',
  medium: 'Medium',
  large: 'Large',
};

export function PieceTray({ player, selectedSize, onSelectSize, onDragStart, onDragEnd }: PieceTrayProps) {
  const hex = COLOR_HEX[player.color];

  return (
    <div className="piece-tray">
      <p className="tray-hint">
        {selectedSize
          ? `${SIZE_LABELS[selectedSize]} selected — tap a cell or drag to place`
          : 'Select a piece to place'}
      </p>
      <div className="tray-pieces">
        {SIZES.map((size) => {
          const count = player.pieces[size];
          const isSelected = selectedSize === size;
          const { viewSize, r, sw } = PIECE_VISUAL[size];

          return (
            <div
              key={size}
              className={`piece-slot${isSelected ? ' selected' : ''}${count === 0 ? ' depleted' : ''}`}
              draggable={count > 0}
              onClick={() => count > 0 && onSelectSize(size)}
              onDragStart={() => count > 0 && onDragStart(size)}
              onDragEnd={onDragEnd}
              title={`${SIZE_LABELS[size]}: ${count} remaining`}
            >
              <svg
                width={viewSize}
                height={viewSize}
                viewBox={`0 0 ${viewSize} ${viewSize}`}
                style={{ display: 'block' }}
              >
                <circle
                  cx={viewSize / 2} cy={viewSize / 2} r={r}
                  fill="none"
                  stroke={count > 0 ? hex : '#3a4f66'}
                  strokeWidth={sw}
                  opacity={count > 0 ? 1 : 0.3}
                />
              </svg>
              <span className="piece-count">{count}</span>
              <span className="piece-label">{SIZE_LABELS[size]}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
